import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { gateSessionsAPI } from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { queuePathFor } from '../../utils/queuePath';

// Old session-based URLs (/operator/sequence/:id, /supervisor/gate/:id) — that
// page was merged into the gate queue page. Resolve the session's gate and
// forward there, so bookmarks and links from before the merge keep working.
export default function SessionQueueRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    gateSessionsAPI.getById(id)
      .then(res => navigate(queuePathFor(user?.role, res.data.data.gate_id, id), { replace: true }))
      .catch(() => setFailed(true));
  }, [id, user, navigate]);

  if (failed) {
    return (
      <div className="px-4 py-8 text-center">
        <AlertCircle size={40} className="text-gray-300 mx-auto mb-3" />
        <p className="text-gray-500">Session not found</p>
        <button onClick={() => navigate(-1)} className="mt-4 text-blue-600 text-sm font-medium">Go back</button>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
